import { useFocusTrap } from '@websolutespa/bom-mixer-hooks';
import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useLlm } from '../../../useLlm/useLlm';
import { useLlmView } from '../../../useLlm/useLlmView';

export const Main: React.FC = () => {
  const {
    Canvas,
    Header,
    Intro,
    Prompt,
    Scroller,
    ScrollProposition,
    Thread,
  } = useLlm(state => state.components);
  const app = useLlm(state => state.app);
  const theme = useLlm(state => state.theme);
  const messages = useLlm(state => state.messages);
  const introed = useLlmView(state => state.introed);
  const visible = useLlmView(state => state.visible);
  const embedded = useLlmView(state => state.embedded);

  const reveal = {
    hidden: {
      opacity: 0,
      scale: .98,
    },
    show: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: .3,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        duration: .3,
        delay: .3,
      },
    },
  };

  const intro = {
    hidden: {
      opacity: 0,
    },
    show: {
      opacity: 1,
      transition: {
        delay: .6,
        duration: .5,
      },
    },
  };

  const slideIn = (direction: number) => ({
    hidden: {
      y: `${100 * direction}%`,
    },
    show: {
      y: 0,
      transition: {
        type: 'tween',
        delay: app?.contents.customIntro ? 0 : 1.2,
        duration: .6,
      },
    },
    exit: {
      y: `${100 * direction}%`,
      transition: {
        type: 'tween',
        duration: .3,
      },
    },
  });

  const shouldShowPrompt = (!app?.contents.customIntro || introed);

  const trapRef = useRef<HTMLDivElement>(null);
  // !!! do not remove
  const [trap, setTrap] = useFocusTrap(trapRef, { disabled: embedded });

  return (
    <motion.div
      className="llm__main"
      key="main-container"
      variants={reveal}
      initial="hidden"
      animate="show"
      exit="exit"
      data-main
      data-lenis-prevent
      ref={trapRef}
    >
      {visible && (
        <Canvas />
      )}
      {!embedded && (
        <motion.div
          className="llm__top"
          variants={slideIn(-1)}
          initial="hidden"
          animate="show"
          exit="exit"
        >
          <Header />
        </motion.div>
      )}
      <Scroller>
        <motion.div
          variants={intro}
          initial="hidden"
          animate="show"
          className="llm__content">
          <Intro />
          {messages && messages.length > 0 && <Thread />}
        </motion.div>
      </Scroller>
      {shouldShowPrompt && (
        <>
          {app && !theme.canvas?.enabled && (
            <div className="llm__underlay" aria-hidden />
          )}
          <motion.main
            className="llm__bottom"
            variants={slideIn(1)}
            initial="hidden"
            animate="show"
            exit="exit"
          >
            <ScrollProposition />
            <Prompt />
          </motion.main>
        </>
      )}
    </motion.div>
  );
};

